<figure>
  @if (dataSignal().img && dataSignal().img !== null) {
  <div class="flex">
    <img
      [src]="replaceBucket.replaceBucket(dataSignal().img)"
      [alt]="dataSignal().title || 'รูปภาพข่าวสาร'"
      [title]="dataSignal().title || 'รูปภาพข่าวสาร'"
      class="item-image"
      loading="lazy"
    />
  </div>
  } @else {
  <div class="item-image"></div>
  }
  <figcaption>
    <h2 class="font-size-22 font-weight-bold text-title">{{ dataSignal().title }}</h2>
    <div class="font-size-16 font-weight-regular text-content" [innerHTML]="getSafeHtml(dataSignal().contentHTML || '')"></div>
    <!-- <div class="flex flex-col">
      <p class="text-seo-title">{{ dataSignal().seoPageTitle }}</p>
      @if(dataSignal().seoUrl){
      <a href="{{ dataSignal().seoUrl }}" class="font-color-black text-seo-title">{{ dataSignal().seoUrl }}</a>
      }
    </div>

    <p class="text-seo-description">{{ dataSignal().seoMetaDescription }}</p> -->
  </figcaption>
</figure>
